module.exports = __webpack_public_path__ + "media/images/users/user-2-ca6c6499d050d693a43dcf92b10f2a1f.jpg";